import { isTokenExpired } from './jwtHelper'

import { auth0 } from '../utils/Auth0'

/*global showTalkdeskHeader*/

var headerShown = false
var talkdesk_error = false
export default class Talkdesk {

  loggedIn(){
    // Checks if there is a saved token and it's still valid
    const token = this.getToken()
    return !!token && !isTokenExpired(token)
  }

  setInstallationId(id){
    localStorage.setItem('talkdesk_installation_id', id)
  }

  getInstallationId(){
    return localStorage.getItem('talkdesk_installation_id')
  }

  setUserId(id){
    localStorage.setItem('talkdesk_user_id', id)
  }

  getUserId(){
    return localStorage.getItem('talkdesk_user_id')
  }

  setToken(token){
    //we remove the previous Auth0 JWT
    auth0.logout()

    localStorage.setItem('talkdesk_token', token)
    this.refreshHeader()
  }

  getToken(){
    return localStorage.getItem('talkdesk_token')
  }

  setError(){
    talkdesk_error = true
    this.refreshHeader()
  }

  //this is also called in the Main component
  refreshHeader() {
    if ( !headerShown ) {
      if ( this.loggedIn() || talkdesk_error) {
        headerShown = true
        showTalkdeskHeader()
      }
    }
  }

  logout(){
    localStorage.removeItem('talkdesk_installation_id');
    localStorage.removeItem('talkdesk_user_id');
    localStorage.removeItem('talkdesk_token');
  }
}

export const talkdesk = new Talkdesk();



// WEBPACK FOOTER //
// ./src/utils/Talkdesk.js